<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/categoria-propaganda"
                    >Categorias de Propaganda</a
                  >
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Categoria </a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">
                Cadastrar Categoria
              </h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Titulo</label>
          <input
            type="text"
            class="form-control"
            v-model="state.nome"
            placeholder="Insira o titulo da categoria"
          />
        </div>
        <div class="col-4">
          <label>Página</label>
          <select
            v-model="state.pagina"
            class="form-select"
            @change="arrayPosition"
          >
            <option value="home">Home</option>
            <option value="noticia">Notícia</option>
            <option value="video">Notícia Vídeo</option>
            <option value="parceiros">Parceiros</option>
            <option value="contato">Contato</option>
            <option value="privacidade">Política de Privacidade</option>
          </select>
        </div>
        <div class="col-4">
          <label>Posicão</label>
          <select
            @change="arrayDimension"
            v-model="state.posicao"
            class="form-select"
          >
            <option
              v-for="position in state.position"
              :key="position"
              :value="position"
            >
              {{ position }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <label>Dimensões</label>
          <select v-model="state.dimensoes" class="form-select">
            <option
              v-for="dimension in state.dimension"
              :key="dimension"
              :value="dimension"
            >
              {{ dimension }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div>
          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="button"
            @click="salvarCategoria()"
          >
            Cadastrar
          </button>
          <button
            class="btn btn_voltar btn-secondary float-end me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'categoriaProganda' })"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    const state = reactive({
      id: "",
      nome: "",
      dimensoes: "",
      pagina: "",
      posicao: "",
      position: [],
      dimension: [],
    });

    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchCategoria();
      }
    });
    async function fetchCategoria() {
      try {
        const { data } = await services.categoria.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.titulo = data.titulo;
        state.titulo_url = data.titulo_url;
        state.status = data.status;
      } catch (error) {
        console.log(error);
      }
    }
    async function arrayPosition(pagina) {
      var position;
      if (pagina.target.value == "home") {
        state.position = ["topo", "meio"];
      } else if (pagina.target.value == "noticia") {
        state.position = ["direita", "meio"];
      } else if (pagina.target.value == "video") {
        state.position = ["direita", "esquerda", "meio"];
      }
      console.log(position);
      console.log(pagina.target.value);
    }
    async function arrayDimension(posicao) {
      var dimension;
      if (posicao.target.value == "topo") {
        state.dimension = ["1200x180"];
      } else if (posicao.target.value == "meio") {
        state.dimension = ["1200x180"];
      } else if (posicao.target.value == "direita") {
        state.dimension = ["400x400"];
      } else if (posicao.target.value == "esquerda") {
        state.dimension = ["400x400"];
      }
      console.log(dimension);
    }
    async function salvarCategoria() {
      let dados = {
        nome: state.nome,
        dimensoes: state.dimensoes,
        pagina: state.pagina,
        posicao: state.posicao,
        token,
      };
      if (!state.id) {
        try {
          await services.categoria.saveCatPropaganda(dados, token);
          router.push({ name: "categoriaProganda" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.id = state.id;
        try {
          await services.categoria.update({ dados, token });
          router.push({ name: "categorias" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      salvarCategoria,
      arrayPosition,
      arrayDimension,
      router,
      state,
    };
  },
};
</script> 

<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
.btn_salvar:hover {
  color: #fff;
}

.card {
  min-height: 94.8vh;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>